import { C } from "../core/config.js";
import { state } from "../core/state.js";
import { btnStyle } from "../core/utils.js";
import { render } from "./app.js";

export function showConfirmDelete(title, message, onConfirm) {
  state.confirmAction = onConfirm;
  state.modal = `
    <div data-action="close-modal-bg" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;z-index:1000;padding:11px;">
      <div data-action="prevent-close" style="background:white;border-radius:14px;width:460px;max-width:100%;box-shadow:0 20px 60px rgba(0,0,0,.2);">
        <div style="padding:10px 12px;border-bottom:1px solid ${C.border};background:#f8fafc;">
          <h3 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">${title}</h3>
        </div>
        <div style="padding:11px;">
          <div style="background:#fee2e2;border:1px solid #fca5a5;border-radius:6px;padding:10px;margin-bottom:9px;">
            ${message}
            <div style="font-size:10.5px;color:${C.muted};margin-top:8px;">Esta acción no se puede deshacer.</div>
          </div>
          <div style="display:flex;gap:10px;justify-content:flex-end;">
            <button data-action="close-modal" style="${btnStyle(null,"secondary")}">Cancelar</button>
            <button data-action="confirm-delete" style="${btnStyle(C.red)}">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  `;
  render();
}

import { registerActions } from "./actions.js";
import { cancelarAutoguardado } from "../modules/documentos.js";

registerActions({
  "confirm-delete": (d, el, e) => {if (state.confirmAction) state.confirmAction();
      return;},
  ...(() => { const __h_close_modal = (d, el, e) => {state.modal = null;
      cancelarAutoguardado();
      state.editingDoc = null;
      state.editingMaestro = null;
      state.confirmAction = null;
      state.editingPagoOcpId = null;
      state.editingPago = null;
      state.viewLiquidacionOpId = null;
      state.multiOcp = null;
      state.editingNC = null;
      render();
      return;}; return { "close-modal": __h_close_modal, "close-modal-bg": __h_close_modal }; })(),
  "prevent-close": (d, el, e) => {return;},
});
